import { addBreadcrumb } from './addBreadcrumb.ts';
import { configure } from 'safe-stable-stringify';

export const stringifyJson = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subject: any,
  options?: { deterministic?: boolean; pretty?: boolean; strict?: boolean },
): string => {
  const stringify = configure({
    // Note that `deterministic=true` has performance implications.
    // https://github.com/BridgeAR/safe-stable-stringify/issues/54
    deterministic: options?.deterministic ?? false,
    // Do not add maximumBreadth and maximumDepth options.
    // The default implementation simply replaces overflowing entries with a string:
    // '... 511 items not stringified', i.e. breaks everything.
    // Also note that many use cases require pretty wide objects, defeating the purpose of this option.
    // maximumBreadth: 10,
    // maximumDepth: 10,
    strict: options?.strict ?? true,
  });

  try {
    if (options?.pretty) {
      return stringify(subject, null, 2) as string;
    }

    return stringify(subject) as string;
  } catch (error) {
    addBreadcrumb({
      data: {
        subject,
      },
      level: 'error',
      message: 'could not stringify JSON',
    });

    throw error;
  }
};
